export type QueryKeyPart = string | number | boolean | null | undefined;

/** Typed, hierarchical keys shared by repositories and invalidations. */
export function createQueryKeys<const TNamespace extends string>(
  namespace: TNamespace,
) {
  const all = [namespace] as const;

  return {
    all,
    lists: () => [...all, "list"] as const,
    list: (params?: Readonly<Record<string, QueryKeyPart>>) =>
      [...all, "list", params ?? {}] as const,
    details: () => [...all, "detail"] as const,
    detail: (id: string) => [...all, "detail", id] as const,
    summary: () => [...all, "summary"] as const,
  };
}

export const queryKeys = {
  auth: createQueryKeys("auth"),
  tenantBranding: createQueryKeys("tenant-branding"),
  tenantResolve: createQueryKeys("tenant-resolve"),
  companies: createQueryKeys("companies"),
  accountAdmins: createQueryKeys("account-admins"),
  roles: createQueryKeys("roles"),
  assetTypes: createQueryKeys("asset-types"),
  assets: createQueryKeys("assets"),
  subscriptions: createQueryKeys("subscriptions"),
  modules: createQueryKeys("modules"),
  currencies: createQueryKeys("currencies"),
  branches: createQueryKeys("branches"),
  branchManagement: createQueryKeys("branch-management"),
  regions: createQueryKeys("regions"),
  departments: createQueryKeys("departments"),
  countries: createQueryKeys("countries"),
  governorates: createQueryKeys("governorates"),
  notifications: createQueryKeys("notifications"),
  devices: createQueryKeys("devices"),
  deviceTypes: createQueryKeys("device-types"),
  deviceBrands: createQueryKeys("device-brands"),
  deviceModels: createQueryKeys("device-models"),
  sensors: createQueryKeys("sensors"),
  gprsCommands: createQueryKeys("gprs-commands"),
  alerts: createQueryKeys("alerts"),
  drivers: createQueryKeys("drivers"),
  driverAssignments: createQueryKeys("driver-assignments"),
  operationalUsers: createQueryKeys("operational-users"),
  profile: createQueryKeys("profile"),
} as const;
